'use strict'


const keyList ={
  "WHILE" : "kaman",
  "ELSE" : "si_no",
  "FOR" : "para_cada",
  "IN" : "uku",
  "IF" : "mikuni",
  "FIN" : "kuturi",
  "VAR" : "willana",
  "PROC" : "kallari",
  "ASK" : "tapuna",
  "PRINT" : "rikuchina",
  "RETURN" : "kutiman",
  "ENTONCES" : "rurana"
}

const regexNumber = /^[0-9]*$/gm;


const CodeGeneratorStyles = Object.freeze({
  setStyle: function (VueCodeMirror,mode) {
    VueCodeMirror.CodeMirror.defineMode(mode, () => {
      return {
        token(stream) {
          if (stream.match(keyList.IF)) {
            return 'keyword'
          } else if (stream.match(keyList.ELSE)) {
            return 'keyword'
          }
          else if (stream.match(keyList.PROC)) {
            return 'keyword'
          }
          else if (stream.match(keyList.WHILE)) {
            return 'keyword'
          }
          else if (stream.match(keyList.ENTONCES)) {
            return 'keyword'
          }
          else if (stream.match(keyList.FIN)) {
            return 'keyword'
          }
          else if (stream.match(keyList.VAR)) {
            return 'def'
          }
          else if (stream.match('(')||stream.match(')')) {
            return 'variable-2'
          }
          else if (stream.match(keyList.PRINT)||stream.match(keyList.ASK)) {
            return 'type'
          }
          else if (stream.match(':')||stream.match('=')) {
            return 'atom'
          }
          else if (stream.match('?')||stream.match('&')) {
            return 'atom'
          }
          else if (stream.match('|')||stream.match(';')) {
            return 'atom'
          }
          else if (stream.match('*')||stream.match('/')) {
            return 'atom'
          }
          else if (stream.match('+')||stream.match('-')) {
            return 'atom'
          }
          else if (stream.match('%')||stream.match(',')) {
            return 'atom'
          }
          else if (stream.match('/')||stream.match('/')) {
            return 'atom'
          }
          else if (stream.match('$')) {
            return 'comment'
          }
          else if (stream.match( regexNumber )) {
            return 'def'
          }
          else {
            stream.next()
            return 'string'
          }
        }
      }
    })

  },
})

export default CodeGeneratorStyles
